import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'idb-theme-mode';

const ThemeModeContext = createContext({ mode: 'light', toggleMode: () => {} });

export const ThemeModeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
        } catch (e) {
            return 'light';
        }
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', mode);
        try {
            localStorage.setItem(STORAGE_KEY, mode);
        } catch (e) {
            // ignore storage failures (private browsing, etc.)
        }
    }, [mode]);

    const toggleMode = () => setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));

    const value = useMemo(() => ({ mode, toggleMode }), [mode]);

    return (
        <ThemeModeContext.Provider value={value}>
            {children}
        </ThemeModeContext.Provider>
    );
};

export const useThemeMode = () => useContext(ThemeModeContext);
